import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { getI18nLanguageFromLocalStorageOrDefaultI18nLanguage } from 'src/shared/helpers/getPreferredLanguage';

import { captureException } from 'src/shared/helpers/captureException';
import { i18nConfig } from './i18n.config';

import { languageLoader, isAsync } from './localeLoader';

i18n.use(initReactI18next)
    .use(languageLoader())
    .init(
        {
            ...i18nConfig,
            lng: getI18nLanguageFromLocalStorageOrDefaultI18nLanguage(),
            initImmediate: !isAsync,
        },
        error => {
            if (error) captureException(error);
        },
    );

export default i18n;
